import { render, staticRenderFns } from "./warningInfo.vue?vue&type=template&id=0588a4d3"
import script from "./warningInfo.vue?vue&type=script&lang=js"
export * from "./warningInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports